import { UISref } from "@uirouter/react";
import styled from "styled-components";
import { match } from "ts-pattern";
import { Button } from "../../../components/button";
import { TextField } from "../../../components/forms/text";
import { Icon } from "../../../components/icons";
import { Flex } from "../../../components/layout";
import { Spinner } from "../../../components/loader/icon";
import { Widget } from "../../../components/widget";
import { names } from "../route-names";
import { useAllMerchants } from "./all-merchants.hook";
import { useDebouncedInput } from "./debounced-input.hook";
import { PresentationalMerchantsList } from "./presentational";

const Wrapper = styled(Flex).attrs({ centered: true })`
  justify-content: center;
  height: 20em;
`;

export const MerchantsComponent = () => {
  const { debouncedValue, setValue, value } = useDebouncedInput();
  const resource = useAllMerchants(debouncedValue);

  return (
    <Widget
      title="All Merchants"
      adornment={
        <UISref to={names.new}>
          <a>
            <Button variant="contained">
              <Icon type="plus" />
            </Button>
          </a>
        </UISref>
      }
    >
      <TextField
        value={value}
        onChange={(e) => setValue(e.target.value)}
        fullWidth
        type="text"
        label="Search"
      />
      {match(resource)
        .with({ status: "loading" }, () => (
          <Wrapper>
            <Spinner />
          </Wrapper>
        ))
        .with(
          {
            status: "error",
          },
          ({ error }) => <>{error.message}</>
        )
        .with(
          {
            status: "success",
          },
          ({ data }) => <PresentationalMerchantsList usersList={data} />
        )
        .otherwise(() => null)}
    </Widget>
  );
};
